(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isTransparentPage = this.hasAttribute('data-transparent-page');
      this.hideLogoOnScroll = this.hasAttribute('data-hide-logo-on-scroll');
      this.hideLogoAtTop = this.hasAttribute('data-hide-logo-at-top');
      this.scrollThreshold = parseInt(this.getAttribute('data-scroll-threshold') || '85', 10);
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.header.classList.add('shopify-section-header-sticky');
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const firstSectionHeight = window.innerHeight * (this.scrollThreshold / 100);
      const pastHeader = scrollTop >= firstSectionHeight;

      // Maintain `scrolled-past-header` on EVERY page, not only transparent
      // ones. header-styles.liquid hangs the configured scrolled background
      // and text colours off this class, so inner pages — which have neither
      // data-transparent-page nor data-hide-logo-at-top — never received it,
      // fell back to the Dawn colour scheme, and turned white on scroll.
      // That is what made the white wordmark invisible on collection pages.
      this.header.classList.toggle('scrolled-past-header', pastHeader);

      if (this.isTransparentPage || this.hideLogoAtTop) {
        this.header.classList.remove('shopify-section-header-hidden');
        if (!pastHeader) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');

      if (this.hideLogoOnScroll) {
        if (scrollTop > 100) {
          this.header.classList.add('logo-hidden');
        } else {
          this.header.classList.remove('logo-hidden');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
